import React from 'react';
import { Switch, Route } from 'react-router-dom';
import useConfig from 'app/hooks/useConfig';
import Landing from './LandingPages';

export default () => {
  const { routes } = useConfig();

  return (
    <Switch>
      <Route path={routes.landing.pattern} component={Landing} exact />
      {/* <Route path={routes.landingSlug.pattern} component={Landing} exact /> */}
      {/* <Route path={routes.landingId.pattern} component={Landing} exact />
      <Route path={routes.landingSlug.pattern} component={Landing} exact /> */}
    </Switch>
  );
};
